function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { Space, Modal, Button } from '@nackle/paper';
import { InfoCircleOutlined } from '@ant-design/icons';
const openModals = [];
export default class UnsavedChangesModal extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      isModalVisible: false
    });
    _defineProperty(this, "handleOkClick", async () => {
      const {
        onSave
      } = this.props;
      const {
        successCallback,
        failCallback
      } = this.state;
      try {
        if (typeof onSave === 'function') {
          await onSave();
        }
        this.setState({
          isModalVisible: false
        }, successCallback);
      } catch (error) {
        this.setState({
          isModalVisible: false
        }, failCallback);
      }
    });
    _defineProperty(this, "handleCancelClick", async () => {
      const {
        onDiscard
      } = this.props;
      const {
        successCallback,
        failCallback
      } = this.state;
      try {
        if (typeof onDiscard === 'function') {
          await onDiscard();
        }
        this.setState({
          isModalVisible: false
        }, successCallback);
      } catch (error) {
        this.setState({
          isModalVisible: false
        }, failCallback);
      }
    });
    _defineProperty(this, "handleCloseClick", () => {
      const {
        failCallback
      } = this.state;
      this.setState({
        isModalVisible: false
      }, failCallback);
    });
    _defineProperty(this, "shouldShow", () => {
      return !this.props.disabled;
    });
    _defineProperty(this, "show", (successCallback, failCallback) => {
      this.setState({
        isModalVisible: true,
        successCallback,
        failCallback
      });
    });
  }
  componentDidMount() {
    this.restorePathname = location.pathname;
    openModals.push(this);
  }
  componentWillUnmount() {
    const index = openModals.indexOf(this);
    if (index >= 0) {
      openModals.splice(index, 1);
    }
  }
  componentDidUpdate(prevProps) {
    if (!prevProps.showModal && this.props.showModal) {
      this.setState({
        isModalVisible: true
      });
    }
  }
  render() {
    const {
      saving,
      className
    } = this.props;
    const {
      isModalVisible
    } = this.state;
    return /*#__PURE__*/React.createElement(Modal, {
      title: /*#__PURE__*/React.createElement(Space, null, /*#__PURE__*/React.createElement(InfoCircleOutlined, {
        style: {
          color: '#1890ff'
        }
      }), /*#__PURE__*/React.createElement("span", null, "Save Changes")),
      className: className,
      visible: isModalVisible,
      onCancel: this.handleCloseClick,
      closable: true,
      cancelButtonProps: {
        ghost: true,
        danger: true
      },
      footer: [/*#__PURE__*/React.createElement(Button, {
        key: "discard",
        ghost: true,
        danger: true,
        onClick: this.handleCancelClick
      }, "Discard"), /*#__PURE__*/React.createElement(Button, {
        key: "submit",
        type: "primary",
        loading: saving,
        onClick: this.handleOkClick
      }, "Save")]
    }, /*#__PURE__*/React.createElement("p", null, "You have unsaved changes. Click the Save button to ensure your changes are saved. If you wish to discard your changes, click Discard."));
  }
}
UnsavedChangesModal.getOpenModals = () => {
  return [...openModals];
};
UnsavedChangesModal.routerMiddleware = function unsavedChangesMiddleware(action, nextRoute, prevRoute) {
  if (openModals.length === 0) {
    action.ok();
    return;
  }
  const modal = openModals[openModals.length - 1];
  if (!modal) {
    action.ok();
    return;
  }
  if (!modal.shouldShow()) {
    action.ok();
    return;
  }
  modal.show(action.ok, action.cancel);
};
//# sourceMappingURL=unsaved-changes-modal.js.map